import React, {Component} from 'react';
import PropTypes from 'prop-types';
import UploadFileModal from "../modals/UploadFileModal";
import OpenFileDialog from "../utils/components/OpenFileDialog";
import {errorToast} from "../utils/toasts";

class FileUploader extends Component {
    static propTypes = {
        entityId: PropTypes.number.isRequired,
        entityName: PropTypes.string.isRequired,
        propertyName: PropTypes.string.isRequired,
        onUpload: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        showUploadModal: false,
        files: []
    };

    render() {
        const {entityId, entityName, propertyName, onUpload} = this.props;

        return (
            <div>
                <OpenFileDialog ref={el => this.openFileDialog = el}
                                multiple={true}
                                onChange={files => this.uploadFiles(files)}/>
                <UploadFileModal entityId={entityId}
                                 entityName={entityName}
                                 propertyName={propertyName}
                                 files={this.state.files}
                                 onUpload={onUpload}
                                 show={this.state.showUploadModal}
                                 onHide={() => this.setState({showUploadModal: false})}/>
            </div>
        );
    }

    open() {
        this.openFileDialog.open()
    }

    uploadFiles(files) {
        if (files.length === 0)
            return;

        files = files.map(file => ({
            name: file.name.substr(0, file.name.lastIndexOf('.')),
            extension: file.name.substr(file.name.lastIndexOf('.')),
            size: file.size,
            nativeFile: file
        }));

        let invalidSize = files
            .filter(file => file.size > this.maxSize)
            .map(file => file.name + file.extension);
        if (invalidSize.length > 0) {
            errorToast(`Размер следующих файлов превышает допустимое значение в 30 Мбайт:\n${invalidSize.join('\n')}`);
            return;
        }

        this.setState({
            showOpenFileDialog: false,
            showUploadModal: true,
            files: files
        });
    }
}

export default FileUploader;


// WEBPACK FOOTER //
// ./src/components/FileUploader.js